import { jsx as _jsx } from "react/jsx-runtime";
import { CheckOutlined, CloseOutlined, CopyOutlined, DeleteOutlined, DownOutlined, EditOutlined, EllipsisOutlined, FolderAddOutlined, FolderOpenOutlined, FolderOutlined, LoadingOutlined, LockOutlined, ReloadOutlined, SaveOutlined, SearchOutlined, SwapOutlined } from "@ant-design/icons";
const ICON_BY_TYPE = {
    check: CheckOutlined,
    close: CloseOutlined,
    copy: CopyOutlined,
    delete: DeleteOutlined,
    down: DownOutlined,
    edit: EditOutlined,
    ellipsis: EllipsisOutlined,
    "folder-add": FolderAddOutlined,
    "folder-open": FolderOpenOutlined,
    folder: FolderOutlined,
    loading: LoadingOutlined,
    lock: LockOutlined,
    reload: ReloadOutlined,
    save: SaveOutlined,
    search: SearchOutlined,
    swap: SwapOutlined
};
const LegacyIcon = ({ type, spin, style, className, onClick })=>{
    const IconComponent = type && ICON_BY_TYPE[type] || FolderOutlined;
    return /*#__PURE__*/ _jsx(IconComponent, {
        spin: spin || type === "loading",
        style: style,
        className: className,
        onClick: onClick
    });
};
export { LegacyIcon };
